import { addProp } from "@pnp/odata";
import { _Site } from "../sites/types.js";
import { Features } from "./types.js";
addProp(_Site, "features", Features);
//# sourceMappingURL=site.js.map